let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cs3js")).then(() => parcelRequire('cwiJf'));